<!-- eslint-disable vue/no-v-html -->
<template>
  <!-- 모달 -->
  <div
    class="modal-wrapper type-alert confirm-modal"
    :class="{ 'is-show': alertPopup.isPopupVisible }"
  >
    <span class="bg-cover" />
    <div class="dialog-modal modal type-confirm">
      <div class="modal-wrap">
        <div class="dialog-content modal-cont is-show">
          <p class="dialog-tt modal-cont-ttl" style="white-space: pre-line">
            {{ alertPopup.title }}
          </p>
          <p class="dialog-txt modal-cont-txt" style="white-space: pre-line">
            {{ alertPopup.desc }}
          </p>
        </div>
        <div class="dialog-button btn-grp type-agree">
          <button
            type="button"
            class="btn btn-full btn-dialog btn-confirm-modal"
            @click="alertPopup.onClose"
          >
            {{ alertPopup.yes }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlertDialog",
  data() {
    return {
      isShowModal: false,
    };
  },
};
</script>

<style scoped></style>
